// extracted by mini-css-extract-plugin
export var baseButton = "_oi-0";
export var controlsArrowKeys = "_oi-1";
export var controlsResetButton = "_oi-2";
export var lightGameButton = "_oi-4 _oi-0";
export var playAgainButton = "_oi-5 _oi-0";
export var startGameButton = "_oi-3 _oi-0";